import { createContext, ReactNode } from 'react'
import { BannerType } from 'components/Banner'
import { noop } from 'utils'

type BannerId = string

export interface BannerParameters {
  dismissible?: boolean
  onDismiss?: () => void
  message: ReactNode
  type?: BannerType
  id?: BannerId
}

export interface BannerItem {
  id: string
  message: React.ReactNode
  type: BannerType
  dismissible: boolean
}

const bannerContext = createContext({
  items: [] as BannerItem[],
  showBanner: (parameters: BannerParameters) => ({
    dismissBanner: noop,
  }),
  dismissBanner: (id: BannerId) => {},
})

export default bannerContext
